
import ourTeam from "@/mixins/data.js"
import ourMissionProducts from "@/mixins/data.js"
import featured from "@/mixins/data.js"
import ClientHead from "@/components/main/core/ClientHead";
import GreyHeadBox from "@/components/main/core/GreyHeadBox";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import RedSection from "@/components/main/core/RedSection";
import GreySection from "@/components/main/core/GreySection";
import CheckBox from "@/components/main/core/CheckBox";

import anon from "@/assets/images/main/our-mission/team/anon.png"
import MainButton from "@/components/main/buttons/MainButton";
import SavedModal from "@/components/main/popups/SavedModal";


export default {
  name: "career",
  layout: 'clientLayout',
  head() {
    const title = 'Career Opportunities - Join iFindCheaters';
    const description = 'Join the iFindCheaters team and contribute to building a more transparent world. We\'re seeking passionate individuals with technical skills to help protect people from deception. Submit your resume today to be part of our mission.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Career Opportunities, Jobs, Remote Jobs, Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, catch cheating spouse, hidden profile finder, find hidden dating profiles, verify spouse online, online infidelity search'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/career/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Career",
            }],
          }
        }
      ]
    };
  },

  mixins: [ourTeam, ourMissionProducts, featured],
  components: { RedHeadBox, ClientHead, GreyHeadBox, GreySection, RedSection, CheckBox, MainButton, SavedModal,  },
  data() {
    return {
      anon,
      showModal: false,
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    showToggle() {
      this.showModal = true
    }
  }
}
